import * as actions from './actions'
import * as getters from './getters'
import * as mutations from './mutations'
import state from './state'
import {
  criarStateToolParts,
  toolPartsActions,
  toolPartsGetters,
  toolPartsMutations,
} from './toolParts'
import {
  criarStateArtefato,
  artefatoActions,
  artefatoGetters,
  artefatoMutations,
} from './artefato'
import {
  criarStateBoasVindas,
  boasVindasActions,
  boasVindasGetters,
  boasVindasMutations,
} from './boas-vindas'
// ★ [E-72] Os ARQUIVOS entregues pelo agente na conversa (o cartão de
// download da bolha). Slice autocontido pelo mesmo motivo dos três acima —
// e composto SÓ aqui: quem o despacha é a bolha do Modo Agente, que só
// existe neste namespace (as outras superfícies não têm run de agente).
import {
  criarStateArtefatosDoWorkspace,
  artefatosDoWorkspaceActions,
  artefatosDoWorkspaceGetters,
  artefatosDoWorkspaceMutations,
} from './artefatos-do-workspace'

/**
 * O slice `toolParts` (spec-001 `plataforma-por-chat`, [T006]) entra no namespace
 * RAIZ, como os demais canais do turno (`pendingConfirmation`, `painelStreaming`):
 * quem consome parametriza só o namespace (`messages.vue` → prop `storeModule`),
 * e um sub-módulo aninhado obrigaria cada leitor a carregar um caminho extra.
 * Os mesmos quatro pedaços são compostos em `feeFixoIa` (fee-fixo/store/ia.js) e
 * em `aiFramework` (ai-framework/store/index.js).
 *
 * ★ `state` segue sendo OBJETO, e não função, de propósito: os units existentes
 * leem `intelligenceV2Store.default.state` e o clonam com `structuredClone`, que
 * lança `DataCloneError` sobre função. O isolamento entre os três namespaces não
 * depende disso — vem de `criarStateToolParts()`, chamada uma vez por composição,
 * que devolve mapa e ordem PRÓPRIOS (state de módulo espalhado raso compartilha
 * os slices aninhados; medido em 2026-08-02 no módulo fee-fixo).
 */
export default {
  namespaced: true,
  state: {
    ...state,
    ...criarStateToolParts(),
    ...criarStateArtefato(),
    ...criarStateBoasVindas(),
    ...criarStateArtefatosDoWorkspace(),
  },
  actions: {
    ...actions,
    ...toolPartsActions,
    ...artefatoActions,
    ...boasVindasActions,
    ...artefatosDoWorkspaceActions,
  },
  getters: {
    ...getters,
    ...toolPartsGetters,
    ...artefatoGetters,
    ...boasVindasGetters,
    ...artefatosDoWorkspaceGetters,
  },
  mutations: {
    ...mutations,
    ...toolPartsMutations,
    ...artefatoMutations,
    ...boasVindasMutations,
    ...artefatosDoWorkspaceMutations,
  },
}
